import { Phone, FileText, MessageSquare } from "lucide-react";
import { useScrollTo } from "@/hooks/useScrollTo";
import { BUSINESS } from "@/utils/constants";

// Mobile-only sticky Call / Text / Request Quote bar.
export const FloatingActions = () => {
  const scrollTo = useScrollTo();
  return (
    <div data-testid="floating-actions" className="lg:hidden fixed bottom-0 left-0 right-0 z-40 flex gap-px border-t border-white/10 bg-ink/95 backdrop-blur-md">
      <a data-testid="floating-call" href={BUSINESS.phoneHref} className="flex-1 flex flex-col items-center justify-center gap-0.5 py-3 text-white font-semibold text-xs uppercase tracking-wide">
        <Phone size={18} className="text-weld-glow" /> Call
      </a>
      <a data-testid="floating-text" href={BUSINESS.smsHref} className="flex-1 flex flex-col items-center justify-center gap-0.5 py-3 text-white font-semibold text-xs uppercase tracking-wide">
        <MessageSquare size={18} className="text-weld-glow" /> Text
      </a>
      <button data-testid="floating-quote" onClick={() => scrollTo("contact")} className="flex-1 flex flex-col items-center justify-center gap-0.5 py-3 bg-weld text-ink font-bold text-xs uppercase tracking-wide">
        <FileText size={18} /> Quote
      </button>
    </div>
  );
};
